import {
    DIC
} from '@/const/dic'
import {
    formatterTime
} from '@/util/util'
import {
    baseUrl
} from '@/config/env';




export const logOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: false,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    columnBtn: false,
    // gutter: 180,
    menuWidth: '200',
    // labelPosition: 'top',
    labelWidth: '110',
    // menuType:'menu',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "商品名称",
            prop: "name",
            type: "input",
            span: 13,
        },

        {
            label: '品牌名称',
            prop: 'brandName',
            span: 13,
            formsolt: true,
        },
        // {
        //     label: '产品型号',
        //     prop: 'type',
        //     type: "input"
        // },
        {
            label: '商品单位',
            prop: 'unit',
            span: 13,
            type: "input"
        },
        {
            label: '进货价格',
            prop: 'stockPrice',
            span: 13,
            editVisdiplay: false,
            type: "input"
        },
        {
            label: '采购价格',
            prop: 'purchasePrice',
            span: 13,
            editVisdiplay: false,
            type: "input"
        },
        {
            label: '零售价格',
            prop: 'salePrice',
            span: 13,
            editVisdiplay: false,
            type: "input"
        },
        // {
        //     label: '品牌名称',
        //     prop: 'brandName',
        //     span: 13,
        //     editVisdiplay:false,
        //     formsolt: true,
        // },
        {
            label: '一级分类',
            prop: 'firstClassifyName',
            span: 13,
            formsolt: true
        }, {
            label: '二级分类',
            prop: 'secondClassifyName',
            span: 13,
            formsolt: true
        },
        {
            label: 'SKU组合',
            prop: 'sku',
            hide: true,
            span: 13,
            formsolt: true
        },
        {
            label: "商品属性",
            prop: "properties",
            // solt: true,
            editVisdiplay: false,
            formsolt: true
        },
        {
            label: "商品属性和价格",
            labelPosition: "top",
            prop: "constitute",
            span: 24,
            solt: true,
            hide: true,
            formsolt: true,
            // rules: [{
            //     required: true,
            //     trigger: "blur",
            //     message: "请选择SKU"
            // }]
        },
        {
            label: '入库量',
            prop: 'amount',
            span: 13,
            type: 'input',
            editVisdiplay: false,
            addVisdiplay: false
        },
        {
            label: '商品状态',
            prop: 'productStatus',
            solt: true,
            type: "radio",
            span: 13,
            dicData: DIC.PRODUCT_STATUS,
            valueDefault: 'PUTAWAY',
            formsolt: true,
            hide: true,
            //addVisdiplay:false
        },
        {
            label: "入库时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '入库人',
            prop: 'createBy',
            addVisdiplay: false,
            search: true,
            editVisdiplay: false
        },
        {
            label: "商品详情",
            prop: "describeImgs",
            span: 24,
            hide: true,
            formsolt: true,
            solt: true,
        },
        {
            label: "商品轮播",
            prop: "wheelsImgs",
            span: 24,
            solt: true,
            formsolt: true,
            hide: true,
        },
        {
            label: "入库时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            hide: true,
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};